<template>
	<div class="login-cta">
		<p class="title">{{ title }}</p>
		<p class="message">{{ message }}</p>
		<Button type="button" :variant="subtle ? 'secondary' : 'primary'" size="m" class="action" @click="goToLogin">
			<AppIcon :name="IconName.LogIn" :size="16" :stroke-width="1.75" />
			{{ t("loginCta.action") }}
		</Button>
	</div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router"
import { useI18n } from "vue-i18n"
import AppIcon from "@/components/AppIcon.vue"
import Button from "@/components/ui/Button.vue"
import { IconName } from "@/components/icons/registry"
import { Route } from "@/utils/routing"

defineProps<{
	title: string
	message: string
	subtle?: boolean
}>()

const { t } = useI18n()
const router = useRouter()

function goToLogin(): void {
	router.push({ name: Route.Login })
}
</script>

<style scoped>
.login-cta {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-xxs);
	padding: var(--spacing-sm) var(--spacing-md);
	border: var(--border-width-thin) solid var(--neutral-100);
	border-radius: var(--border-radius-lg);
	background: color-mix(in srgb, var(--neutral-50) 50%, transparent);

	p {
		margin: 0;
	}

	.title {
		color: var(--neutral-900);
		font-size: var(--font-size-small);
		font-weight: var(--font-weight-medium);
	}

	.message {
		color: var(--neutral-600);
		font-size: var(--font-size-xs);
	}

	.action {
		width: 100%;
		gap: var(--spacing-xs);
		margin-top: var(--spacing-sm);
	}
}
</style>
